import fetchData from './fetchData'
import { parseJSON, checkHttpStatus } from '../shared/utils'
import config from '../config/index'

function getChatbotRequestConfig(method, body) {
  const requestConfig = {
    method,
    headers: {
      Authorization: `Bearer ${config.api.chatbotJwtToken}`,
    },
  }

  if (body) {
    requestConfig.headers['Content-Type'] = 'application/json'
    requestConfig.body = JSON.stringify(body)
  }

  return requestConfig
}


/**
 * Edit seller group.
 * @param params {{idnum: string, sellers: string[]}}
 * @returns {Promise<unknown>}
 */
async function editGroup(params) {
  const { idnum, sellers } = params
  const sessionId = localStorage.getItem('sessionId')
  const formattedSellers = JSON.stringify(sellers.map(seller => ({ idnum: parseInt(seller) })))

  const url = new URL(config.api.baseUrl)
  url.searchParams.set('class', 'user')
  url.searchParams.set('action', 'updateGROUP')
  url.searchParams.set('sessionID', sessionId)
  url.searchParams.set('sellers', formattedSellers)
  url.searchParams.set('idnum', idnum)
  return fetchData(url.toString(), 'POST')
    .then((res) => {
      if (!res.ok) {
        return res.json().then((err) => {
          throw new Error(err.message)
        })
      }
      return res
    })
    .then(parseJSON)
    .then(checkHttpStatus)
    .then(response => response.result)
}

/**
 * Edit seller group.
 * @param params {{idnum: string, sellers: string[]}}
 * @returns {Promise<unknown>}
 */
async function createGroup(params) {
  const { sellers, name } = params
  const sessionId = localStorage.getItem('sessionId')
  const formattedSellers = JSON.stringify(sellers.map(seller => ({ idnum: parseInt(seller) })))
  const url = new URL(config.api.baseUrl)
  url.searchParams.set('class', 'user')
  url.searchParams.set('action', 'createGROUP')
  url.searchParams.set('sessionID', sessionId)
  url.searchParams.set('s_name', name)
  url.searchParams.set('sellers', formattedSellers)

  return fetchData(url.toString(), 'POST')
    .then((res) => {
      if (!res.ok) {
        return res.json().then((err) => {
          throw new Error(err.message)
        })
      }
      return res
    })
    .then(parseJSON)
    .then(checkHttpStatus)
    .then(response => response.result)
}

/**
 * Delete seller group.
 * @param params {{idnum: string}}
 * @returns {Promise<unknown>}
 */
async function deleteSellerGroup(params) {
  const { idnum } = params
  const sessionId = localStorage.getItem('sessionId')

  const url = new URL(config.api.baseUrl)
  url.searchParams.set('class', 'user')
  url.searchParams.set('action', 'deleteGROUP')
  url.searchParams.set('sessionID', sessionId)
  url.searchParams.set('idnum', idnum)
  return fetchData(url)
    .then((res) => {
      if (!res.ok) {
        return res.json().then((err) => {
          throw new Error(err.message)
        })
      }
      return res
    })
    .then(parseJSON)
    .then(checkHttpStatus)
    .then(response => response.result)
}


/**
 * Get sellers by chosen group identification.
 * @param params {{idnum: string}}
 * @returns {Promise<unknown>}
 */
async function getGroupSellers(params) {
  const { idnum } = params
  const sessionId = localStorage.getItem('sessionId')

  const url = new URL(config.api.baseUrl)
  url.searchParams.set('class', 'user')
  url.searchParams.set('action', 'readGROUP')
  url.searchParams.set('sessionID', sessionId)
  url.searchParams.set('idnum', idnum)

  return fetchData(url)
    .then((res) => {
      if (!res.ok) {
        return res.json().then((err) => {
          throw new Error(err.message)
        })
      }
      return res
    })
    .then(parseJSON)
    .then(checkHttpStatus)
    .then(response => response.result)
}

/**
 * Get groups of sellers.
 * @returns {Promise<*>} List of groups.
 */
async function getGroupsOfSellers() {
  const sessionId = localStorage.getItem('sessionId')
  return fetchData(`${config.api.baseUrl}?class=user&action=getGROUPS&sessionID=${sessionId}`)
    .then(parseJSON)
    .then(checkHttpStatus)
    .then(response => response.result)
}

async function sellerGetCount(params, payload) {
  const url = new URL(config.api.baseUrl)
  url.searchParams.set('class', 'seller')
  url.searchParams.set('action', 'getcount')

  for (const [key, value] of Object.entries(params)) {
    if (key === 'sort' || key === 'order') {
      url.searchParams.set(key, value || undefined)
    } else if (key === 'group') {
      if (value) url.searchParams.set(key, value)
    } else {
      url.searchParams.set(key, value || '')
    }
  }
  return fetchData(
    url.toString(),
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function sellerGetPage(params, payload) {
  const {
    current, pageSize, search, sort, order, group,
  } = params

  const url = new URL(config.api.baseUrl)

  url.searchParams.set('class', 'seller')
  url.searchParams.set('action', 'getpage')

  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(params)) {
    if (key === 'sort' || key === 'order') {
      url.searchParams.set(key, value || undefined)
    } else if (key === 'group') {
      if (value) url.searchParams.set(key, value)
    } else {
      url.searchParams.set(key, value || '')
    }
  }

  return fetchData(
    url.toString(),
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function sellerCreate(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=seller&action=create`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function sellerCreateEPO(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=seller&action=createepo`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function sellerRead(values, payload) {
  const { id } = values

  return fetchData(
    `${config.api.baseUrl}?class=seller&action=read&id=${id}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function sellerUpdate(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=seller&action=update`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function sellerUpdateChatToken(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=seller&action=updatechattoken`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function sellerDelete(values, payload) {
  const { id } = values

  return fetchData(
    `${config.api.baseUrl}?class=seller&action=delete&id=${id}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function sellerAddBalance(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=seller&action=addBalance`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function sellerGetButtonMenu(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=seller&action=getButtonMenu`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function sellerUpdateButtonMenu(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=seller&action=updateButtonMenu`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function sellerPointsGetCount(params, payload) {
  const { search } = params

  return fetchData(
    `${config.api.baseUrl}?class=seller&action=getpointscount&search=${search || ''}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function sellerPointsGet(params, payload) {
  const {
    current, pageSize, search, sort, order,
  } = params

  return fetchData(
    `${config.api.baseUrl}?class=seller&action=getpoints&current=${current}&pageSize=${pageSize}&sort=${sort}&order=${order}&search=${search || ''}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function sellerPointCreate(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=seller&action=pointcreate`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function sellerPointRead(values, payload) {
  const { id } = values

  return fetchData(
    `${config.api.baseUrl}?class=seller&action=pointread&id=${id}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function sellerPointUpdate(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=seller&action=pointupdate`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function sellerPointDelete(values, payload) {
  const { id } = values

  return fetchData(
    `${config.api.baseUrl}?class=seller&action=pointdelete&id=${id}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function sellersSimpleList(params, payload) {
  const { search, sort, order } = params

  return fetchData(
    `${config.api.baseUrl}?class=seller&action=simplelist&search=${search || ''}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function sellerChatsGetCount(params, payload) {
  const { search } = params

  return fetchData(
    `${config.api.baseUrl}?class=seller&action=getchatscount&search=${search || ''}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function sellerChatsGet(params, payload) {
  const {
    current, pageSize, sellerId, sellerToken, messengerType = '',
  } = params

  const searchParams = new URLSearchParams({
    current,
    pageSize,
    sellerId: sellerToken,
    sessionId: localStorage.getItem('sessionId'),
    sellerIdMaxbonus: sellerId,
    selectedType: messengerType,
  })

  return fetch(
    `${config.api.chatbotHost}/api/v1/admin_form/get_chatbot_messngers_data?${searchParams}`,
    getChatbotRequestConfig('GET'),
  )
    .then(parseJSON)
}

async function sellerChatCreate(payload) {
  const {
    sellerName,
    sellerId,
    messengerId,
    maxbonusSellerId,
    messengerType,
    apiToken,
    url,
    additionalData,
  } = payload
  return fetch(
    `${config.api.chatbotHost}/api/v1/admin_form/add_chatbot_messenger_data`,
    getChatbotRequestConfig('POST', {
      sellerName,
      sellerId,
      apiToken,
      url,
      messengerId,
      messengerType,
      sessionId: localStorage.getItem('sessionId'),
      maxbonusSellerId,
      additionalData,
    }),
  )
    // Throw error if res not valid.
    .then((res) => {
      if (!res.ok) {
        return res.json().then((err) => {
          throw new Error(err.message)
        })
      }
      return res
    })
    .then(parseJSON)
}

// async function sellerChatRead(values, payload) {
//   const { id } = values
//
//   return fetch(
//     `${config.api.chatbotHost}/api/v1/admin_form/get_chatbot_messngers_data?${searchParams}`,
//     {
//       method: 'GET',
//     },
//   )
//     .then(parseJSON)
//     .then(checkHttpStatus)
// }

async function sellerChatUpdate(payload) {
  const {
    sellerId,
    messengerId,
    maxbonusSellerId,
    additionalData,
    url,
  } = payload
  return fetch(
    `${config.api.chatbotHost}/api/v1/admin_form/update_chatbot_messenger_data`,
    getChatbotRequestConfig('POST', {
      sellerId,
      messengerId,
      sessionId: localStorage.getItem('sessionId'),
      maxbonusSellerId,
      additionalData,
      url,
    }),
  )
    .then(parseJSON)
}

async function sellerChatDelete(values, payload) {
  const {
    apiToken,
    sellerId,
  } = values

  return fetch(
    `${config.api.chatbotHost}/api/v1/admin_form/remove_chatbot_messenger_data`,
    getChatbotRequestConfig('DELETE', {
      apiToken,
      sellerId,
      sessionId: localStorage.getItem('sessionId'),
    }),
  )
}

async function exportForceMTS(values, payload) {
  const { id } = values

  return fetchData(
    `${config.api.baseUrl}?class=seller&action=exportForceMTS&id=${id}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function generateJWT(values, payload) {
  const { id } = values

  return fetchData(
    `${config.api.baseUrl}?class=seller&action=generateJWT&id=${id}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

export {
  getGroupSellers,
  getGroupsOfSellers,
  sellerGetCount,
  sellerGetPage,
  sellerCreate,
  sellerCreateEPO,
  sellerRead,
  sellerUpdate,
  sellerUpdateChatToken,
  sellerDelete,
  sellerAddBalance,
  sellerGetButtonMenu,
  sellerUpdateButtonMenu,
  sellerPointsGetCount,
  sellerPointsGet,
  sellerPointCreate,
  sellerPointRead,
  sellerPointUpdate,
  sellerPointDelete,
  sellersSimpleList,
  sellerChatsGetCount,
  sellerChatsGet,
  sellerChatCreate,
  sellerChatUpdate,
  sellerChatDelete,
  exportForceMTS,
  editGroup,
  createGroup,
  deleteSellerGroup,
  generateJWT
}



// WEBPACK FOOTER //
// src/api/seller.js